import { datatypes, inputTypes } from "data/globalData";

export const sizeLevelBuyingObj = "channelSizeLevBuying";
export const colorsChannelObjName = "colorChannels";
export const colorChannelBuyingObj = "colorChannelLevBuying";
export const colorStyleAssocObj = "colorStyle";
export const styleColorBuyingAssocObj = "styleColorBuying";
export const colorImgAssociationObjName = "colorImages";

export const buyingColorAssocObj = "buyingColor";
export const colorBuyingQtyAssocObj = "colorBuyingQty";
export const colorBuyingWhQtyAssoc = "colorBuyingWhQty";
export const colorBuyingChannelsAssoc = "colorBuyingChannelLevQty";
export const cbChannelsizeQtyAssoc = "colorBuyingSizeQty";

export const deletedRowsObjKey = "deletedRows";

export const sizeTypes = {
	xs: { name: "XS", key: "xs" },
	s: { name: "S", key: "s" },
	m: { name: "M", key: "m" },
	l: { name: "L", key: "l" },
	xl: { name: "XL", key: "xl" },
	xxl: { name: "XXL", key: "xxl" },
	xxxl: { name: "XXXL", key: "xxxl" },
	xxxxl: { name: "XXXXL", key: "xxxxl" },
};

export const channelTypes = {
	EBO: { name: "EBO", key: "EBO" },
	MBO: { name: "MBO", key: "MBO" },
	LFS: { name: "LFS", key: "LFS" },
	D2C: { name: "D2C", key: "D2C" },
	Marketplace: { name: "MARKETPLACE", key: "Marketplace" },
};
export const regions = {
	NORTH: { name: "NORTH", key: "NORTH" },
	SOUTH: { name: "SOUTH", key: "SOUTH" },
	EAST: { name: "EAST", key: "EAST" },
	WEST: { name: "WEST", key: "WEST" },
};

export const wearHouses = {
	GGN: { name: "GGN", key: "GGN", pincode: 122506 },
	JIGANI: { name: "Jigani (BLR)", key: "JIGANI", pincode: 562106 },
	NELAMANGALA: { name: "Nelamangala (BLR)", key: "NELAMANGALA", pincode: 562123 },
};
export const sizeTypeCol = [
	"s1",
	"s2",
	"s3",
	"s4",
	"s5",
	"s6",
	"s7",
	"s8",
	"s9",
	"s10",
	"s11",
	"s12",
	"s13",
	"s14",
	"s15",
	"s16",
	"s17",
	"s18",
	"s19",
	"s20",
	"s21",
	"s22",
	"s23",
	"s24",
	"s25",
	"s26",
	"s27",
	"s28",
	"s29",
	"s30",
];

export const colorBuyTableColumns = {
	total_qty: {
		name: "TotalQty",
		key: "total_qty",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: false, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	final_mrp: {
		name: "Final MRP",
		key: "final_mrp",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	targeted_cogs: {
		name: "Targeted COGS",
		key: "targeted_cogs",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	targeted_multi: {
		name: "Targeted Multi",
		key: "targeted_multi",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	actual_multi: {
		name: "Actual Multi",
		key: "actual_multi",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 0,
	},
	ebo_grade: {
		name: "Ebo Grade",
		key: "ebo_grade",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
	lfs_grade: {
		name: "LFS Grade",
		key: "lfs_grade",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
	ik_grade: {
		name: "Ik Grade",
		key: "ik_grade",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
	mbo_grade: {
		name: "MBO Grade",
		key: "mbo_grade",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},

	mrp_updated_by: {
		name: "Mrp Updated By",
		key: "mrp_updated_by",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: false, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
};
